import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import {
  updateUserData,
  updateMainUserData,
  updateDisplayingHealthForm,
  updateDisplayingTermOfUsePage,
  updateUserToken,
} from "../store/userSlice";
import { useLocation, useNavigate } from "react-router-dom";
import userAPI from "../api/userAPI";
import OtpInput from "react-otp-input";
import { useTranslation } from "react-i18next";
import { encryptClaimNumber } from "../utils/crypto";
import Footer from "../components/Footer";

export default function OtpValidation() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [continueBtn, setContinueBtn] = useState(true);
  const [smsPayload, setSMSPayload] = useState("");
  const [otp, setOtp] = useState("");
  const [displayError, setDisplayError] = useState(false);

  const [timeLeft, setTimeLeft] = useState(0);
  const [displayNoCodeReceived, setDisplayNoCodeReceived] = useState(false);

  const intervalRef = useRef(null);

  useEffect(() => {
    if (location?.state) {
      setSMSPayload(location.state);
    }
  }, [location.state]);

  useEffect(() => {
    if (timeLeft > 0) {
      intervalRef.current = setInterval(() => {
        setTimeLeft((prev) => prev - 1);
      }, 1000);
    } else {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [timeLeft]);

  const resendCode = async (isPhoneCall = false) => {
    if (timeLeft > 0) return;
    setDisplayNoCodeReceived(true);
    setTimeLeft(60);
    await userAPI.sendSmsCode({ ...smsPayload, IsPhoneCall: isPhoneCall });
  };

  const handleUserLogin = async (userParams) => {
    const allUserParams = await userAPI.login({
      Token: userParams?.data.Token,
      ID: userParams?.data.ID,
      Phone: userParams?.data.Phone,
    });
    dispatch(updateUserData(allUserParams));
    if (userParams?.data.ShowHealthConditionStatementForm) {
      navigate("/registrationQuestionnaire");
    } else {
      navigate("/");
    }
  };

  const handleCodeVerified = async (userParams) => {
    dispatch(updateMainUserData({ ...userParams.data, Token: "12" + userParams.data.Token }));
    dispatch(updateDisplayingHealthForm(userParams.data.ShowHealthConditionStatementForm));
    dispatch(updateDisplayingTermOfUsePage(userParams.data.ShowTermOfUseFormConditionStatementForm));
    dispatch(updateUserToken(userParams.data.Token));
    if (userParams.data.Email === "") {
      navigate("/registration");
    } else {
      await handleUserLogin(userParams);
    }
  };

  const onClickContinue = async () => {
    const claimNumber = encryptClaimNumber(smsPayload.ClaimNumber);
    const payload = {
      ...smsPayload,
      ClaimNumber: claimNumber,
      Code: otp,
      DeviceConfStr: "",
      DeviceType: "",
      Token: "",
    };
    const response = await userAPI.verifySmsCode(payload);
    if (response.data?.Error) {
      setDisplayError(true);
    } else {
      handleCodeVerified(response);
    }
  };

  return (
    <div className="user-phone-validation-container">
      <div className="user-phone-validation-wrapper">
        <div className="user-instruction">
          <span className="instruction">{t("OTP_VALIDATION.ENTER_CODE")}</span>
        </div>

        <div className="user-inputs">
          <OtpInput
            value={otp}
            onChange={(otp) => {
              setOtp(otp);
              setContinueBtn(otp.length !== 4);
            }}
            numInputs={4}
            renderSeparator={<span style={{ margin: "3px" }}></span>}
            renderInput={(props) => <input {...props} />}
            inputType={"number"}
            inputStyle={{
              width: "52px",
              height: "52px",
              margin: "5px",
              fontSize: "20px",
              textAlign: "center",
              borderRadius: "12px",
              border: "1px solid #ccc",
            }}
            shouldAutoFocus={false}
          />
          <button className="continue-button" disabled={continueBtn} onClick={() => onClickContinue()}>
            {t("PHONE_VALIDATION.CONTINUE")}
          </button>
          {
            <button className="voice-code" onClick={() => resendCode(true)}>
              {t("OTP_VALIDATION.SEND_VOICE_CODE")}
            </button>
          }
        </div>

        {displayNoCodeReceived && (
          <div className="didnt-get-code-container">
            <p className="didnt-get-code-message">{t("OTP_VALIDATION.DIDNT_GET_SMS")}</p>
            <p className="didnt-get-code-message">
              {t("OTP_VALIDATION.CONTACT_SUPPORT")} <a href="tel:033730300">03-3730300</a>
            </p>
          </div>
        )}

        {displayError && (
          <div className="error-message-container">
            <span className="error-message">{t("OTP_VALIDATION.WRONG_CODE")}</span>
          </div>
        )}

        <div className="voice-code-container">
          {<span className="didnt-get-code">{t("OTP_VALIDATION.DIDNT_GET_CODE")}</span>}
          {
            <button className="voice-code" onClick={() => resendCode(false)}>
              {t("OTP_VALIDATION.SEND_AGAIN")}
            </button>
          }
          {timeLeft > 0 && (
            <span className="error-message">{t("OTP_VALIDATION.SEND_AGAIN_IN", { seconds: timeLeft })}</span>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
}
